import { Box, Stack, Typography } from '@mui/material';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import LockIcon from '@mui/icons-material/Lock';
import SavingsIcon from '@mui/icons-material/Savings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const GiftPromiseCard = () => {
  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' }, // Desktop only
        backgroundColor: '#f8fbff',
        borderRadius: 3,
        p: 3,
        border: '1px solid #e3ebf7',
        mt: 2,
      }}
    >
      {/* Top Stats */}
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Stack spacing={0.5}>
          <Typography fontWeight={700} fontSize={22} color="#0b2e5f">
            5L+
          </Typography>
          <Typography fontSize={13} color="#6b7c93">
            Happy 99Gift users
          </Typography>
        </Stack>

        <Stack spacing={0.5}>
          <Typography fontWeight={700} fontSize={22} color="#0b2e5f">
            ₹10Cr
          </Typography>
          <Typography fontSize={13} color="#6b7c93">
            Saved till date with gift cards
          </Typography>
        </Stack>
      </Stack>

      {/* Divider */}
      <Box sx={{ height: 2, backgroundColor: '#738298', mb: 2 }} />

      {/* Title */}
      <Typography fontSize={13} fontWeight={700} sx={{ color: '#0b2e5f', mb: 2 }}>
        99GIFT PROMISE
      </Typography>

      {/* Promise Points */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', rowGap: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.2} sx={{ width: '50%' }}>
          <FlashOnIcon sx={{ color: '#0b2e5f', fontSize: 20 }} />
          <Typography fontSize={14}>Instant gift card e-delivery</Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1.2} sx={{ width: '50%' }}>
          <SavingsIcon sx={{ color: '#0b2e5f', fontSize: 20 }} />
          <Typography fontSize={14}>Guaranteed savings</Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1.2} sx={{ width: '50%' }}>
          <LockIcon sx={{ color: '#0b2e5f', fontSize: 20 }} />
          <Typography fontSize={14}>Safe & secure payment</Typography>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={1.2} sx={{ width: '50%' }}>
          <SupportAgentIcon sx={{ color: '#0b2e5f', fontSize: 20 }} />
          <Typography fontSize={14}>Zero hassle support</Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default GiftPromiseCard;
